let currentRoute = null;
let previousRoute = null;

export const getPreviousRoute = () => currentRoute;
export const getCurrentRoute = () => previousRoute;

export const updateRoute = (newRoute) => {
  if (currentRoute !== null && currentRoute !== newRoute) {
    previousRoute = currentRoute;
  }
  currentRoute = newRoute;
};
